import moment from 'moment-timezone'

let timezone = 'Asia/Hong_Kong'

if (process.env.REACT_APP_REGION === 'th') {
  timezone = 'Asia/Bangkok'
}

moment.tz.setDefault(timezone)

export default moment
